import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { rightArrow, rightArrowHover, whyUs, whyus2 } from '../../../assets/images';
import AOS from 'aos';
import 'aos/dist/aos.css';

const WhyUsHome = () => {

      const { t, i18n } = useTranslation();
      const currentLanguage = i18n.language; // Aktif dili alıyoruz
 
  useEffect(() => {
    AOS.init({
      duration: 2000,
      once: false,
      offset: 300,
    });
  }, []);

  return (
    <div className='pt-[56px] md:pt-[88px] overflow-x-hidden '> {/* Buraya eklendi */}
      <div className='min-h-[800px] md:min-h-min'>
        <div className='max-w-containerSm md:max-w-container mx-auto'>
          <div className='md:flex justify-between items-end' data-aos="fade-up">
           <div>
             <p className='text-[28px] md:text-[40px] font-medium text-[#2a3d63]'>{t("Cortex Construction")}</p>
            <p className='text-[16px] text-[#767676] font-secondFont'>
              {t("Azərbaycanın inşaat sektorunda innovativ yanaşma və etibarlı tərəfdaşlıq təqdim edən peşəkar tikinti şirkəti")}
            </p> 
           </div>
           <div className='mt-8 md:mt-0 flex justify-center md:block font-secondFont bg-white'>
             <a href={`/${currentLanguage}/about`}>
          <button className='w-[165px] h-[48px] bg-white rounded-[2px]'>{t("Daha ətraflı")}</button>
        </a>
           </div>
          </div>

          <div className='relative md:flex items-center mt-8 hidden'>
            <div className='w-[54%] ml-auto z-0' data-aos="fade-left">
              <img className='w-full h-full object-cover' src={whyus2} alt="why us image" />
            </div>

            <div className='absolute left-0 z-10 w-[48%] bg-[white] py-5 px-6 border border-[#E5E5E5] rounded-[12px]' data-aos="fade-right">
              <p className='text-[#1C1C1C] font-medium text-[24px] font-secondFont'>{t("İnşaat Sektorunda Güvən və Keyfiyyətin Təmsilçisi")}</p>
              <p className='mt-3 text-[#1C1C1C] font-secondFont'>
                {t("“Cortex Construction” MMC olaraq, Azərbaycanın inşaat sektorunda yeni yaşayış məkanları, müasir ofis binaları və davamlı infrastruktur layihələri üçün etibarlı bir tərəfdaş axtarırsınızsa, Cortex Construction sizin üçün doğru seçimdir. Biz innovativ yanaşmalar, yüksək keyfiyyətli materiallar və peşəkar komandamızla hər bir layihəni unikal şəkildə həyata keçiririk. Sizin arzularınız, bizim uğurumuzdur!")}
              </p>
              <a href={`/${currentLanguage}/about`} className="group">
                <div className='flex items-center mt-3 justify-between w-[100px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px]'>
                  <p className='transition-colors duration-300 group-hover:text-[#2a3d63]'>{t("Ətraflı")}</p>
                  <img
                    className='w-2 transition-opacity duration-300 group-hover:hidden'
                    src={rightArrow}
                    alt=""
                  />
                  <img
                    className='w-2 transition-opacity duration-300 hidden group-hover:block'
                    src={rightArrowHover}
                    alt=""
                  />
                </div>
              </a>
            </div>
          </div>
      {/* Mobil versiyon */}
<div className='relative md:hidden items-center mt-8 '>
  {/* Yukarı div */}
  <div className='ml-auto z-0'>
    <img className='w-full h-full object-cover' src={whyus2} />
  </div>

  {/* Aşağı div - yukarı divin üstüne 20px çıksın */}
  <div className='absolute top-[190px] left-0 z-10 bg-[white] py-5 px-6 border border-[#E5E5E5] rounded-[12px]'>
    <p className='text-[#1C1C1C] font-medium text-[18px] font-secondFont'>{t("Rahatlıq və Etibarlılığın Ünvanı")}</p>
    <p className='mt-3 text-[#1C1C1C] font-secondFont'>
      {t("Şirkətimiz iri və kiçik həcmli zavod və fabriklərin, neft və qaz sektoru, sənaye və iaşə obyektlərinin, mehmanxana və çoxmərtəbəli iş mərkəzlərinin, luks yaşayış binalarının, idman və konsert komplekslərinin, stadionların, ticarət mərkəzlərinin, xəstəxanaların, məktəblərin, universitetlərin MEP sistemlərinin quraşdırılması və servisinin yerinə yetirilməsində 25 ilə yaxın dolğun təcrübəyə malikdir.")}
    </p>
   <div className='font-secondFont'>
     <a href={`/${currentLanguage}/about`}>
      <div className='flex items-center mx-auto mt-3 justify-between w-[100px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px] px-3'>
        <p>{t("Ətraflı")}</p>
        <img className='w-2' src={rightArrow} />
      </div>
    </a>
   </div>
  </div>
</div>
        </div>
      </div>
    </div>
  )
}

export default WhyUsHome;
